import m from './1.0.0';

export default m;
